import React from "react";
import { useRendererInitializer } from "../hooks/rendererInitializer.hook";
import { css } from "emotion";
import { usePixiInitializer } from "../hooks/pixiInitializer.hook";
import { ProcessNode, type ProcessNodeProps } from "../SComponents/ProcessNode";
import {
  handleHTMLDragLeave,
  handleHTMLDragOver,
  handleHTMLDrop
} from "../engines/interactionEngine/interactionObserverHTML";
import { ProcessLayoutMode } from "@certa/studio-core";
import { ProcessFlowNode } from "../SComponents/ProcessFlowNode";

export const ProcessDesigner = React.memo((props: ProcessNodeProps) => {
  const { stageContainerRef } = usePixiInitializer();
  const FsComponent =
    props.layoutMode === ProcessLayoutMode.FLOW_VIEW
      ? ProcessFlowNode
      : ProcessNode;

  useRendererInitializer({
    props,
    data: props.process,
    fsComponent: FsComponent
  });

  return (
    <div
      className={css({
        position: "relative",
        height: "100vh",
        width: "100%",
        overflow: "hidden"
      })}
    >
      <div
        id="certa-designer-stage"
        ref={stageContainerRef}
        onDragLeave={handleHTMLDragLeave}
        onDragOver={handleHTMLDragOver}
        onDrop={handleHTMLDrop}
        className={css({
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 2,
          overflow: "hidden",
          width: "100vw"
        })}
      ></div>
    </div>
  );
});
